export default "__VITE_ASSET__BXgs5zmO__"